import { TicketScheduleComponent } from '../ticket-schedule/ticket-schedule.component';
import {
  AfterViewInit,
  Component,
  HostListener,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from '@angular/material/dialog';
import { FetchPolicy } from '@apollo/client/core';
import { TicketsService } from '../../services/tickets.service';
import { AuthService } from '@core/services/auth.service';
import { BusLookupService } from '@core/services/bus-lookup.service';
import { NotifyService } from '@core/services/notify.service';
import { UserService } from '@shared/services/user.service';
import { TktLookupService } from '../../../tickets-setup/service/tkt-lookup.service';
import { TicketStatusChangeService } from '../../services/ticket-status-change.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  Ticket,
  UpdateTicketDueDate,
  UpdateTicketPlanDateRange,
  UpdateTicketPriority,
} from '../../models/tickets';
import {
  TicketsStatusChange,
  UpdateTicketPrimaryAssignee,
  UpdateTicketStatus,
} from '../../models/ticket-status-change';
import moment from 'moment';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { AddTeamMemberAndHourComponent } from '../add-team-member-and-hour/add-team-member-and-hour.component';
import { NoteAttachments, Notes } from '@core/model/note/note';
import { busLookupsCategory, busLookupsModuleCode, lookupStatus } from '@core/enums/bus-Lookup';
import { ConvertDateUtcTimezoneService } from '@shared/services/convert-date-utc-timezone.service';
import { TicketLabor } from '../../models/ticket-labor';
import { TeamHourComponent } from '../team-hour/team-hour.component';
import { BusLookup } from '@core/model/bus-lookup/bus-lookup';
import { AddHourComponent } from '../add-hour/add-hour.component';
import { DropdownToggleService } from '@shared/services/dropdown-toggle.service';
import { ConfirmationDialogComponent } from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { TicketLabourService } from '../../services/ticket-labour.service';
import { LaborRateType } from '@core/enums/ticket-labor';
import { AppPermissions } from '@core/app.config';
import { LocationComponent } from '../location/location.component';

type Tabs =
  | 'DetailsActivities'
  | 'AddHours'
  | 'TeamHours'
  | 'Location'
  | 'Equipment'
  | 'Attachments';
@Component({
  selector: 'app-ticket-detail-popup',
  standalone: false,
  templateUrl: './ticket-detail-popup.component.html',
  styleUrl: './ticket-detail-popup.component.css',
})
export class TicketDetailPopupComponent implements OnInit, AfterViewInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedDate: any;
  ticket: Ticket = new Ticket();
  ticketLat: string;
  ticketLng: string;
  form: FormGroup;
  selectedTicketId: string;
  selectedTicketNo: string;
  createdOn: Date;
  lastActivity: Date;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dueDate: any;
  planStartEndDate: any;
  dateLocale = {
   format: 'MM/DD/YYYY HH:mm', // → e.g., May 2, 2025
  };
  formDueDate: FormGroup;
  formPlanDate: FormGroup;
  lastNote: NoteAttachments[] = [];
  lastNoteId: string;
  lastNoteDetail: Notes;
  LookupModuleCode = 'TKT';
  lookupCategoryCode = busLookupsCategory.Ticket;
  assignedUserId: string;
  isManager = false;
  isChangeAnyThing = 0;
  refreshNotes = false;
  latestChangeStatus: TicketsStatusChange;
  isCompleted = false;
  timeZone: string;
  @ViewChild(TeamHourComponent) teamHourComponent!: TeamHourComponent;
  @ViewChild(AddHourComponent) addTeamHourComponent!: AddHourComponent;
  statusList: BusLookup[] = [];
  priorityList: BusLookup[] = [];
  lookupModuleCOde = busLookupsModuleCode;
  selectedPriorityId: string;
  selectedStatusId: string;
  teamMembersAdded: false;
  minSelectableDate: dayjs.Dayjs;
  loading = false;
  onSubmitPlanDateErrorMessage: string;
  onSubmitPlanStartDateError = false;
  onSubmitPlanEndDateError = false;
  laborList: TicketLabor[] = [];
  changePrimaryAssignee = 0;
  activeTab: Tabs = 'DetailsActivities';
  isLoadingTabs = false;
//

  changePriorityRead;
  changePriorityWrite;
  //
  changeAssigneeRead;
  changeAssigneeWrite;
  //
  changeWorkerRead;
  changeWorkerWrite;
  //
  changeLabHrsRead;
  changeLabHrsWrite;
  //
  changeTicketDueDateRead;
  changeTicketDueDateWrite;
  //
 recurringTicketRead;
  recurringTicketWrite;
  //
   changeTicketStatusRead;
  changeTicketStatusWrite;
  //
  ChangeTicketPlanDateRead;
  ChangeTicketPlanDateWrite;
  //
  NotesAndDetailsRead;
  NotesAndDetailsWrite;
  //
  AddHoursRead;
  AddHoursWrite;
  //
  TeamHoursRead;
  TeamHoursWrite;
  //
  TicketLocationRead;
  TicketLocationWrite;
  //
  TicketEquipmentRead;
  TicketEquipmentWrite;
  //
  TicketAttachmentsRead;
  TicketAttachmentsWrite;
  //


  constructor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<TicketDetailPopupComponent>,
    public service: TicketsService,
    private authService: AuthService,
    public userService: UserService,
    public busService: BusLookupService,
    public ticketLookupService: TktLookupService,
    private notifyService: NotifyService,
    private statusService: TicketStatusChangeService,
    public utcToTimeZone: ConvertDateUtcTimezoneService,
    private dialog: MatDialog,
    private fbDueDate: FormBuilder,
    protected dropdownService: DropdownToggleService,
    private laborService: TicketLabourService,
  ) {

    this.initForm();
    this.isChangeAnyThing = 0;

    this.dialogRef.keydownEvents().subscribe((event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        this.cancel(); // only closes this dialog
      }
    });
  }
  setTab(tab: Tabs) {
    this.activeTab = tab;
  }

  activeClass(tab: Tabs) {
    return tab === this.activeTab
      ? 'bg-[#141414] text-white'
      : 'hover:bg-[#F9F9F9]';
  }
  cancel() {
    this.dialogRef.close(this.isChangeAnyThing);
  }

  async ngOnInit(fetchPolicy?: FetchPolicy) {

    if (this.data.id) {
      this.selectedTicketId = this.data.id;
    }
    this.isLoadingTabs = true;
    await this.getTicketData(fetchPolicy);
    if (this.ticket) {
      dayjs.extend(customParseFormat);
      // Assign with correct format to the min and max date
      this.minSelectableDate = dayjs(
        this.ticket?.entryDate,
        'M/D/YYYY h:mm:ss A'
      );
      this.checkIsManager();
      this.latestChangeStatus = this.getLatestChangeStatus(this.ticket);
      this.assignedUserId = this.latestChangeStatus?.assignedUserId;
      if (this.latestChangeStatus.statusLookup.code === lookupStatus.COMPL)
        this.isCompleted = true;
      this.fillPopup();
      this.ticketLaborList();
      const ticketFirstStatus = await this.findOldestTicketStatusChange(
        this.ticket
      );
      this.ticketLat = ticketFirstStatus.latitude;
      this.ticketLng = ticketFirstStatus.longitude;

      const [status, priority] = await Promise.all([
        this.busService.getLookupDataByParentModuleCode(
          this.lookupModuleCOde.TktStatus
        ),
        this.busService.getLookupDataByParentModuleCode(
          this.lookupModuleCOde.Priority
        ),
      ]);
      this.statusList = status;
      this.priorityList = priority;

      // ✅ Apply alphanumeric sorting to priorityList
      this.priorityList = this.sortLookupHierarchy(this.priorityList);

      // now that priorityList is ready, set the id
      this.selectedPriorityId =
        this.ticket?.priorityLookup.priorityName ?? null;
      this.selectedStatusId = this.ticket?.currentChangeStatusId ?? null;
      //Set timezone
      const timeZone = localStorage.getItem('timeZones');
      if (timeZone) {
        const parsedTimeZone = JSON.parse(timeZone); // Parse if stored as a JSON string
        this.timeZone = parsedTimeZone[0]; // Use the first time zone (or adjust as needed)
      }
      const selectedTicketTimeZone = this.ticket?.facility?.timeZone;
      if (selectedTicketTimeZone) this.timeZone = selectedTicketTimeZone;
      await this.userRights();
      this.isLoadingTabs = false;
    }

    this.initForm();
  }

  checkIsManager() {
    if (this.ticket?.facility?.siteManagerId === this.authService.id)
      this.isManager = true;
  }

  initForm() {

    // ✅ 1. Due Date (keep this same as you wrote)
    // const dateStr = this.getUTCDate(this.ticket?.dueDate ?? this.ticket?.entryDate);
    const dateStr = this.ticket?.dueDate ?? this.ticket?.entryDate;
    const parsedDate = moment(dateStr, 'M/D/YYYY h:mm:ss A', true);

    this.formDueDate = this.fbDueDate.group({
      dueDate: parsedDate.isValid()
        ? { startDate: parsedDate, endDate: parsedDate }
        : null,
    });

    const formValue = this.formDueDate.get('dueDate')?.value;

    if (formValue) {
      console.log(
        'Start Date:',
        formValue.startDate?.format('M/D/YYYY h:mm:ss A')
      );
      console.log('End Date:', formValue.endDate?.format('M/D/YYYY h:mm:ss A'));
    } else {
      console.log('Due date is null or invalid');
    }

    // ✅ 2. Plan Start and End Date (new)
    let startStr = this.ticket?.planStartDate ?? dayjs().toDate();
    let endStr = this.ticket?.planEndDate ?? dayjs().add(1, 'hour').toDate();

    startStr = this.getUTCDate(startStr);
    endStr = this.getUTCDate(endStr);

    const startDate = moment(startStr, 'M/D/YYYY h:mm:ss A', true);
    const endDate = moment(endStr, 'M/D/YYYY h:mm:ss A', true);

    this.formPlanDate = this.fbDueDate.group({
      planDate:
        startDate.isValid() && endDate.isValid()
          ? { startDate, endDate }
          : null,
    });

    const planValue = this.formPlanDate.get('planDate')?.value;

    if (planValue) {
      console.log(
        'Plan Start:',
        planValue.startDate?.format('M/D/YYYY h:mm:ss A')
      );
      console.log('Plan End:', planValue.endDate?.format('M/D/YYYY h:mm:ss A'));
    } else {
      console.log('Plan date is null or invalid');
    }
  }

  async getTicketData(fetchPolicy?: FetchPolicy) {
    if (this.selectedTicketId) {
      const getTicket = await this.service.getTicketsGrid(
        this.selectedTicketId,
        fetchPolicy
      );
      if (getTicket) {

      const [labors, statusChanges] = await Promise.all([
          this.laborService.getTicketLaborsByTicketIds([getTicket.id]),
          this.statusService.getTicketStatusChangeByTicketIds([getTicket.id]),
        ]);

        this.ticket = {
          ...getTicket,
          ticketLabor: labors || [],
          ticketStatusChanges: statusChanges || [],
        };
      }
    }

  }
  fillPopup() {
    this.selectedTicketNo = this.ticket?.ticketNo;
    this.createdOn = this.parseCustomDate(this.ticket.entryDate.toString());
    // const localDate = this.utcToTimeZone.convertUTCToLocalTime(
    //         this.ticket.dueDate,
    //         this.ticket?.facility?.timeZone
    //           ? this.ticket?.facility?.timeZone
    //           : this.timeZone
    //       );

    this.dueDate =this.calendarDateFormat(this.ticket.dueDate);
    //Start End Date
    // const localStartDate = this.utcToTimeZone.convertUTCToLocalTime(
    //         this.ticket.planStartDate,
    //         this.ticket?.facility?.timeZone
    //           ? this.ticket?.facility?.timeZone
    //           : this.timeZone
    //       );
    // const localEndDate = this.utcToTimeZone.convertUTCToLocalTime(
    //         this.ticket.planEndDate,
    //         this.ticket?.facility?.timeZone
    //           ? this.ticket?.facility?.timeZone
    //           : this.timeZone
    //       );
    const localStartDate = this.ticket.planStartDate;
    const localEndDate = this.ticket.planEndDate;

    this.planStartEndDate = this.calendarStartEndDateFormat(
      localStartDate,
      localEndDate
    );
  }

  parseCustomDate(dateStr: string): Date {
    const [datePart, timePart, meridian] = dateStr.split(' ');
    const [day, month, year] = datePart.split('/').map(Number);
    const [hourRaw, minute, second] = timePart.split(':').map(Number);

    let hour = hourRaw;
    if (meridian.toLowerCase() === 'pm' && hour !== 12) hour += 12;
    if (meridian.toLowerCase() === 'am' && hour === 12) hour = 0;

    return new Date(year, month - 1, day, hour, minute, second);
  }

  getTotalEstimatedHours(ticket: Ticket): number {
    if (!ticket?.ticketLabor || !Array.isArray(ticket.ticketLabor)) return 0;

    return ticket.ticketLabor.reduce((acc: number, labor: TicketLabor) => {
      return acc + (labor.estimated || 0);
    }, 0);
  }

  getTotalCost(ticket: Ticket): number {
    if (!ticket?.ticketLabor || !Array.isArray(ticket.ticketLabor)) return 0;

    return ticket.ticketLabor.reduce((acc: number, labor: TicketLabor) => {
      return labor.hoursType?.toUpperCase() === LaborRateType.Regular
        ? acc + (labor.rate || 0)
        : acc;
    }, 0);
  }

  getTotalWorkerHours(ticket: Ticket): number {
    if (!ticket?.ticketLabor || !Array.isArray(ticket.ticketLabor)) return 0;

    return ticket.ticketLabor.reduce((acc: number, labor: TicketLabor) => {
      return labor.hoursType?.toUpperCase() === LaborRateType.Regular
        ? acc + (labor.hours || 0)
        : acc;
    }, 0);
  }

  getTotalEstimatedLaborCost(ticket: Ticket): number {
    if (!ticket?.ticketLabor || !Array.isArray(ticket.ticketLabor)) return 0;

    return ticket.ticketLabor.reduce((total: number, labor: TicketLabor) => {
      if (labor.hoursType?.trim().toUpperCase() === LaborRateType.Regular) {
        const cost = Number(labor.estimated || 0) * Number(labor.rate || 0);
        return total + cost;
      }
      return total;
    }, 0);
  }

  getTotalRegularLaborCost(ticket: Ticket): number {
    if (!ticket?.ticketLabor || !Array.isArray(ticket.ticketLabor)) return 0;

    return ticket.ticketLabor.reduce((total: number, labor: TicketLabor) => {
      if (labor.hoursType?.trim().toUpperCase() === LaborRateType.Regular) {
        const cost = Number(labor.hours || 0) * Number(labor.rate || 0);
        return total + cost;
      }
      return total;
    }, 0);
  }

  getLatestChangeStatus(ticketChange: Ticket): TicketsStatusChange | undefined {
    if (ticketChange?.ticketStatusChanges?.length > 0) {
      return ticketChange.ticketStatusChanges.reduce<
        TicketsStatusChange | undefined
      >(
        (latest, change) => {
          if (!latest?.changeOn) return change;
          if (!change.changeOn) return latest;
          return new Date(latest.changeOn) > new Date(change.changeOn)
            ? latest
            : change;
        },
        undefined // initial value
      );
    }
    return undefined;
  }

  SetDialogWidth(): string {
    let returnWidth;
    const windowWidth = window.innerWidth;
    switch (true) {
      case windowWidth < 450: {
        returnWidth = '94vw';
        break;
      }
      case windowWidth >= 450 && windowWidth < 750: {
        returnWidth = '94vw';
        break;
      }
      default:
        returnWidth = '480px';
    }
    return returnWidth;
  }

  ticketSchedule(): void {
    const width = this.SetDialogWidth();
    this.service.selectedTicketId = this.selectedTicketId;
    this.dialog.open(TicketScheduleComponent, {
      minWidth: width,
      width: width,
      panelClass: 'overflow_visible',
      hasBackdrop: true,
      disableClose: true,
    });
  }

  private getResponsiveDialogWidth(): string {
    const windowWidth = window.innerWidth;

    if (windowWidth < 450) {
      return '94vw';
    }
    if (windowWidth < 750) {
      return '94vw';
    }
    return '480px';
  }

  SetDialogWidthTeamMember(): string {
    return this.getResponsiveDialogWidth();
  }

  AddTeamMemberAndHour(): void {
    const width = this.SetDialogWidthTeamMember();
    this.service.selectedTicketId = this.selectedTicketId;
    this.service.ticketLaborList = this.ticket.ticketLabor;
    const dialog = this.dialog.open(AddTeamMemberAndHourComponent, {
      minWidth: width,
      width: width,
      panelClass: 'overflow_visible',
      hasBackdrop: true,
      disableClose: true,
      data: {
        estimatedHoursOnly: true,
      },
    });
    dialog.afterClosed().subscribe(async (result) => {
      if (!result) return;

      if (result) {
        this.updateTicket();
        this.getTotalEstimatedHours(this.ticket);
        this.callChild();
      }
    });
  }

  async findOldestTicketStatusChange(item: Ticket) {
    // Ensure ticketStatusChanges array exists
    if (!item?.ticketStatusChanges || item.ticketStatusChanges.length === 0) {
      return null;
    }

    // Find the oldest record based on changeOn field
    const oldestRecord = await item.ticketStatusChanges
      .filter((statusChange) => statusChange.changeOn) // Ensure changeOn exists
      .sort(
        (a, b) =>
          new Date(a.changeOn).getTime() - new Date(b.changeOn).getTime()
      )[0];

    return oldestRecord || null;
  }

  getTicketDescription() {
    return this.ticket?.ticketNoteWithAttachments?.note?.noteText;
  }

  handleLastNoteEvent(note: Notes) {
    this.lastNoteDetail = note;
    this.lastNote = note.attachments;
    this.lastNoteId = note.id;
  }

  getAllLaborList(ticket: Ticket) {
    const distinctLabors = ticket.ticketLabor.reduce((acc, labor) => {
      if (!acc.some((item) => item.workerId === labor.workerId)) {
        acc.push(labor);
      }
      return acc;
    }, []);
    return distinctLabors;
  }

  getDistinctLabor(
    ticket: Ticket,
    excludeWorkerId?: string | number // pass the worker‑id you want to skip
  ): TicketLabor[] {
    if (!ticket?.ticketLabor || !Array.isArray(ticket.ticketLabor)) {
      return [];
    }

    const seen = new Set<string | number>();

    return ticket.ticketLabor
      .filter((labor) => labor.workerId !== excludeWorkerId) // 🔸 skip the one to exclude
      .filter((labor) => {
        // 🔸 keep only first time we see each id
        if (seen.has(labor.workerId)) return false;
        seen.add(labor.workerId);
        return true;
      });
  }

  updateTicket() {
    this.isChangeAnyThing = 1;
    this.ngOnInit('network-only');
  }

  callChild() {
    if (this.teamHourComponent) {
      this.teamHourComponent.ngOnInit();
    }
    if (this.addTeamHourComponent) {
      this.addTeamHourComponent.getData();
    }
  }

  ngAfterViewInit(): void {
    this.callChild();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async onSubmitPlanDate(event: any) {

    let startDate = new Date(event.startDate?.format('M/D/YYYY HH:mm'));

    let endDate =new Date(event.endDate?.format('M/D/YYYY HH:mm'));


    const dueDate = new Date(this.ticket?.dueDate);
    const entryDate = new Date(this.ticket?.entryDate);
    //
    const start = event.startDate;
    const end = event.endDate;
    const startMinutes = start.hour() * 60 + start.minute();
    const endMinutes = end.hour() * 60 + end.minute();
    if(startMinutes > endMinutes){
      this.notifyService.error({
        message: 'Start time must be before end time.',
        type: 'Date validation',
      });
      this.onSubmitPlanDateErrorMessage =
        'Invalid: Start time must be before end time.';
      this.onSubmitPlanStartDateError = true;

      return;
    }
    if (entryDate > startDate) {
      this.notifyService.error({
        message: 'The start date must be greater than the ticket created date.',
        type: 'Date validation',
      });
      this.onSubmitPlanDateErrorMessage =
        'The start date must be earlier than the ticket due date.';
      this.onSubmitPlanStartDateError = true;

      return;
    }
    if (endDate > dueDate) {
      this.notifyService.error({
        message: 'The Ticket plan end date must be earlier than the due date.',
        type: 'Date validation',
      });
      this.onSubmitPlanDateErrorMessage =
        'The Ticket created date must be earlier than the end date.';
      this.onSubmitPlanEndDateError = true;
      return;
    }
    this.onSubmitPlanDateErrorMessage = '';
    this.loading = true;

    //convert it into utc
     startDate = this.utcToTimeZone.convertLocalTimeToUTC(
      new Date(event.startDate?.format('M/D/YYYY HH:mm')),
      this.timeZone
    );
    endDate = this.utcToTimeZone.convertLocalTimeToUTC(
      new Date(event.endDate?.format('M/D/YYYY HH:mm')),
      this.timeZone
    );

    const ticketData: UpdateTicketPlanDateRange =
      new UpdateTicketPlanDateRange();

    ticketData.id = this.ticket.id;
    ticketData.planStartDate = startDate
    ? this.formatDateTime(new Date(startDate))
    : undefined;

    ticketData.planEndDate = endDate
    ? this.formatDateTime(new Date(endDate))
      : undefined;

    ticketData.updatedOn = this.getLocalDate24Hour();

    await this.service
      .updateTicketPlanDate(ticketData)
      .then(async () => {
        this.notifyService.success({
          message: 'Ticket plan dates updated successfully.',
        });
        this.loading = false;
        this.isChangeAnyThing = 1;
        await this.getTicketData();
        this.onSubmitPlanStartDateError = false;
        this.onSubmitPlanEndDateError = false;
      })
      .catch(() => {
        this.notifyService.error({
          message: 'Failed to update ticket plan date',
        });
        this.loading = false;
      });
  }
formatDateTime(date: Date): string {
  const pad = (n: number) => n.toString().padStart(2, '0');

  return (
    date.getFullYear() + '-' +
    pad(date.getMonth() + 1) + '-' +
    pad(date.getDate()) + ' ' +
    pad(date.getHours()) + ':' +
    pad(date.getMinutes()) + ':' +
    pad(date.getSeconds())
  );
}
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async onSubmitDueDate(event: any) {

    if (!event || !event.startDate) return;
    const formValue = event?.startDate;
    if (!formValue) return;
    // Convert to local JS Date (exact time selected in picker)
    var localDate= formValue.format('YYYY-MM-DD HH:mm');

    // const ticketEntryDate = this.utcToTimeZone.convertUTCToLocalTime(this.ticket?.entryDate, this.ticket?.facility?.timeZone ? this.ticket?.facility?.timeZone: this.timeZone);
    if (localDate < new Date(this.ticket?.entryDate)) {
      this.notifyService.error({
        message: 'The due date must be greater than the ticket created date.',
        type: 'Date validation',
      });
      return;
    }

    const localTimeZone = this.utcToTimeZone.convertLocalTimeToUTC(localDate, this.ticket?.facility?.timeZone ? this.ticket?.facility?.timeZone: this.timeZone);

    const ticketData = new UpdateTicketDueDate();
    ticketData.dueDate = localTimeZone;
    ticketData.businessId = this.authService.businessId;
    ticketData.id = this.selectedTicketId;
    ticketData.updatedOn = this.getLocalDate24Hour();
    this.loading = true;

    await this.service
      .updateTicketDueDate(ticketData)
      .then(async () => {
        this.notifyService.success({
          message: 'Ticket due date updated successfully.',
        });
        await this.getTicketData('network-only');
        this.isChangeAnyThing = 1;
        this.loading = false;
      })
      .catch(() => {
        this.notifyService.error({
          message: 'Failed to update due date.',
        });
        this.loading = false;
      });
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async getDateRanges(event: any) {
    const startDate = event.startDate?.format('DD/MM/YYYY HH:mm');
    const endDate = event.endDate?.format('DD/MM/YYYY HH:mm');

    console.log('Start:', startDate);
    console.log('End:', endDate);
  }

  tileColor(lookup: BusLookup): string {
    const settingStr = lookup.setting?.toString();
    const parsed = settingStr ? JSON.parse(settingStr) : undefined;
    return parsed?.tileColor ?? '#3699ff';
  }

  // Helper function to get local date in 24-hour format
  getLocalDate24Hour(): string {

    const localDate = new Date();

    const formattedDate =
      `${localDate.getMonth() + 1}/${localDate.getDate()}/${localDate.getFullYear()} ` +
      `${localDate.getHours().toString().padStart(2,'0')}:` +
      `${localDate.getMinutes().toString().padStart(2,'0')}:` +
      `${localDate.getSeconds().toString().padStart(2,'0')}`;

    return formattedDate;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async onSubmitPriority(event: any) {
    const priorityId = event?.id;
    if (priorityId) {
      const ticketData = new UpdateTicketPriority();
      ticketData.businessId = this.authService.businessId;
      ticketData.id = this.selectedTicketId;
      ticketData.priorityId = priorityId;
      // Use the helper function here
      ticketData.updatedOn = this.getLocalDate24Hour();
      this.loading = true;
      await this.service
        .updateTicketPriority(ticketData)
        .then(async () => {
          this.isChangeAnyThing = 1;
          this.loading = false;
          await this.getTicketData();
        })
        .catch(() => {
          this.notifyService.success({
            message: 'Failed to update ticket priority.',
          });
          this.loading = false;
        });
    } else {
      this.notifyService.error({
        message: 'Please select ticket priority to continue.',
        type: 'Data required',
      });
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async onSubmitStatus(event: any) {
    const statusId = event?.id;
    if (statusId) {
      const ticketData = new UpdateTicketStatus();
      ticketData.businessId = this.authService.businessId;
      ticketData.id = this.selectedTicketId;
      ticketData.currentChangeStatusId = statusId;
      await this.statusService
        .updateTicketStatus(ticketData)
        .then(async () => {
          this.isChangeAnyThing = 1;
          await this.getTicketData();
        })
        .catch(() => {
          this.notifyService.success({
            message: 'Failed to update ticket status.',
          });
        });
    } else {
      this.notifyService.error({
        message: 'Please select ticket status to continue.',
        type: 'Data required',
      });
    }
  }

  getUTCDate(utcDate: Date | null | undefined): Date | null {
    if (!utcDate) return null; // return null if no date provided
    const dateValue = new Date(utcDate);
    const date = new Date(
      this.utcToTimeZone.convertUTCToLocalTime(dateValue, this.timeZone)
    );
    return date;
  }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
  checkChangeAnything(event: any) {
    if (event) {
      this.isChangeAnyThing = event;
    }
  }

  ticketLaborUserList(ticket: Ticket): { displayName: string; pic?: string }[] {
    const distinctUsers: { displayName: string; pic?: string }[] = [];

    const seen = new Set<string>();

    for (const labor of ticket.ticketLabor ?? []) {
      if (
        labor?.workerId &&
        !seen.has(labor.workerId) &&
        labor.workerName &&
        labor?.workerId != this.assignedUserId
      ) {
        seen.add(labor.workerId);
        distinctUsers.push({
          displayName: labor.workerName,
          pic: labor.workerPic ?? undefined,
        });
      }
    }
    return distinctUsers;
  }

  toggleDropdown(id: string, event: MouseEvent): void {
    event.stopPropagation();
    this.dropdownService.toggleDropdown(id);
  }

  // Check if a dropdown is visible
  isDropdownVisible(id: string): boolean {
    return this.dropdownService.isDropdownVisible(id);
  }

  // Hide all dropdowns when clicking anywhere else in the document
  @HostListener('document:click', ['$event'])
  onDocumentClick(): void {
    this.dropdownService.hideAllDropdowns();
  }

  onDivClick(event: MouseEvent): void {
    event.stopPropagation(); // Prevent document click listener from closing dropdown
  }

  getDialogDimensions(): { maxHeight: string; width: string; height: string } {
    const windowWidth = window.innerWidth;

    if (windowWidth < 1030) {
      return { width: '94vw', height: '230px', maxHeight: '98vh' };
    } else {
      return { width: '515px', height: '230px', maxHeight: '98vh' };
    }
  }
  async onRemoveSecondary(selectedWorkerId: string, workerName: string) {
    const { width, height, maxHeight } = this.getDialogDimensions();
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      minWidth: width,
      width: width,
      height: height,
      maxHeight: maxHeight,
      panelClass: 'center-popup',
      hasBackdrop: true,
      disableClose: true,
      data: {
        title: `Are you sure you want to remove`,
        boldTitle: workerName,
        subTitle: 'This member will no longer be part of the ticket.',
        showSubtitle: true,
        showBoldTitle: true,
        confirmButtonText: 'Remove Member',
      },
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        const labor = new TicketLabor();
        const workerId = this.authService.id;
        labor.createdOn = new Date();
        labor.createdById = workerId;
        labor.updatedOn = new Date();
        labor.updatedById = workerId;
        labor.workerId = selectedWorkerId;
        labor.ticketId = this.selectedTicketId;
        labor.hours = 0;
        labor.rate = 0;
        labor.billable = 0;
        labor.hoursType = LaborRateType.Regular;
        await this.laborService
          .removeTicketWorker(labor)
          .then(async () => {
            this.updateTicket();
            this.getTotalEstimatedHours(this.ticket);
            this.callChild();
          })
          .catch((error) => {
            error = error.graphQLErrors[0];
            if (error) {
              this.notifyService.error({
                message: error.message,
                type: error.extensions.type,
              });
            } else {
              this.notifyService.error({
                message: 'Failed to remove ticket member.',
              });
            }
          });
      }
    });
  }
  async ticketLaborList() {
    // Step 1: Remove duplicates based on workerId
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const uniqueLaborsMap = new Map<string, any>();
    this.ticket.ticketLabor.forEach((labor) => {
      if (!uniqueLaborsMap.has(labor.workerId)) {
        uniqueLaborsMap.set(labor.workerId, labor);
      }
    });

    const distinctLabors = Array.from(uniqueLaborsMap.values());

    // Step 2: If assignedUserId exists, move the matching worker to top
    if (this.assignedUserId != null) {
      const idx = distinctLabors.findIndex(
        (l) => l.workerId === this.assignedUserId
      );

      if (idx > -1) {
        const [priorityLabor] = distinctLabors.splice(idx, 1); // remove
        distinctLabors.unshift(priorityLabor); // insert at start
      }
    }

    this.laborList = distinctLabors;
  }

  checkParimaryAssignee(workerId: string) {
    const assigneeId = this.assignedUserId;
    return workerId == assigneeId ? true : false;
  }

  async onSubmitPrimaryAssignee(workerId: string) {
    const labor = new UpdateTicketPrimaryAssignee();
    labor.changeById = this.authService.id;
    labor.assignedUserId = workerId;
    labor.ticketId = this.selectedTicketId;
    this.loading = true;
    await this.statusService
      .updateTicketPrimaryAssignee(labor)
      .then(async () => {
        this.changePrimaryAssignee = 0;
        this.updateTicket();
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        error = error.graphQLErrors[0];
        if (error) {
          this.notifyService.error({
            message: error.message,
            type: error.extensions.type,
          });
        } else {
          this.notifyService.error({
            message: 'Failed to add primary assignee.',
          });
        }
      });
  }

  onChangePrimaryAssignee() {
    this.changePrimaryAssignee = 1;
  }

  checkUserPermissions(permission: string) {
    return this.authService.hasPermission(permission) ?? null;
  }

  canViewPermission(permission: string): boolean {
    const canView =
      this.authService.hasPermission('read:' + permission) ||
      this.authService.hasPermission('write:' + permission);

    return canView;
  }
  isTicketCompleted(event: boolean) {
    this.isCompleted = event;
  }

  calendarDateFormat(rawDueDate: string | Date) {
      if (!rawDueDate) return null;
      const parsedDate = moment(rawDueDate);
      return { startDate: parsedDate, endDate: parsedDate };
    }

    calendarStartEndDateFormat(rawStartDate: string | Date, rawEndDate: string | Date) {
      if (!rawStartDate || !rawEndDate) return null;
      const startDate = moment(rawStartDate);
      const endDate = moment(rawEndDate);
      return { startDate, endDate };
    }

  userRights() {
    //
    this.changePriorityRead = this.authService.hasPermission(
      AppPermissions.ChangePriorityRead
    );
    this.changePriorityWrite = this.authService.hasPermission(
      AppPermissions.ChangePriorityWrite
    );
    //
    this.changeAssigneeRead = this.authService.hasPermission(
      AppPermissions.ChangeAssigneeRead
    );
    this.changeAssigneeWrite = this.authService.hasPermission(
      AppPermissions.ChangeAssigneeWrite
    );
    //
    this.changeWorkerRead = this.authService.hasPermission(
      AppPermissions.ChangeWorkerRead
    );
    this.changeWorkerWrite = this.authService.hasPermission(
      AppPermissions.ChangeWorkerWrite
    );
    //
    this.changeLabHrsRead = this.authService.hasPermission(
      AppPermissions.ChangeLabHrsRead
    );
    this.changeLabHrsWrite = this.authService.hasPermission(
      AppPermissions.ChangeLabHrsWrite
    );
    //
    this.changeTicketDueDateRead = this.authService.hasPermission(
      AppPermissions.ChangeTicketDueDateRead
    );
    this.changeTicketDueDateWrite = this.authService.hasPermission(
      AppPermissions.ChangeTicketDueDateWrite
    );
    //
    this.recurringTicketRead = this.authService.hasPermission(
      AppPermissions.TicketRecurringJobsRead
    );
    this.recurringTicketWrite = this.authService.hasPermission(
      AppPermissions.TicketRecurringJobsWrite
    );
    //
    this.changeTicketStatusRead = this.authService.hasPermission(
      AppPermissions.ChangeTicketStatusRead
    );
    this.changeTicketStatusWrite = this.authService.hasPermission(
      AppPermissions.ChangeTicketStatusWrite
    );
    //
      this.ChangeTicketPlanDateRead = this.authService.hasPermission(
        AppPermissions.ChangeplandatesRead
      );
      this.ChangeTicketPlanDateWrite = this.authService.hasPermission(
        AppPermissions.ChangeplandatesWrite
      );
      //
      this.NotesAndDetailsRead = this.authService.hasPermission(
        AppPermissions.NotesDetailsRead
      );
      this.NotesAndDetailsWrite = this.authService.hasPermission(
        AppPermissions.NotesDetailsWrite
      );
      //--
      this.AddHoursRead = this.authService.hasPermission(
        AppPermissions.AddHoursRead
      );
      this.AddHoursWrite = this.authService.hasPermission(
        AppPermissions.AddHoursWrite
      );
      //
      this.TeamHoursRead = this.authService.hasPermission(
        AppPermissions.TeamHoursRead
      );
      this.TeamHoursWrite = this.authService.hasPermission(
        AppPermissions.TeamHoursWrite
      );
      //
      this.TicketLocationRead = this.authService.hasPermission(
        AppPermissions.TicketlocationRead
      );
      this.TicketLocationWrite = this.authService.hasPermission(
        AppPermissions.TicketlocationWrite
      );
    //
      this.TicketEquipmentRead = this.authService.hasPermission(
        AppPermissions.EquipmentsRead
      );
      this.TicketEquipmentWrite = this.authService.hasPermission(
        AppPermissions.EquipmentsWrite
      );
      //
      this.TicketAttachmentsRead = this.authService.hasPermission(
        AppPermissions.AttachmentsRead
      );
      this.TicketAttachmentsWrite = this.authService.hasPermission(
        AppPermissions.AttachmentsWrite
      );
  }

  // Apply alphanumeric sorting
  private sortAreasByAlphaNumeric(names: string[]): string[] {
    return [...names].sort((a, b) => {
      // Extract letters
      const lettersA = a.match(/[a-zA-Z]+/)?.[0].toLowerCase() || '';
      const lettersB = b.match(/[a-zA-Z]+/)?.[0].toLowerCase() || '';

      // 1️⃣ Sort by letters
      if (lettersA !== lettersB) {
        return lettersA.localeCompare(lettersB);
      }

      // Extract numbers
      const numberA = parseInt(a.match(/\d+/)?.[0] || '0', 10);
      const numberB = parseInt(b.match(/\d+/)?.[0] || '0', 10);

      // 2️⃣ Sort by numbers
      return numberA - numberB;
    });
  }

  private sortLookupHierarchy(list: BusLookup[]): BusLookup[] {
    // Sort all items by name using alphanumeric sorting
    const sortedNames = this.sortAreasByAlphaNumeric(
      list.map(p => p.name || '')
    );

    // Return sorted list maintaining hierarchy structure
    return sortedNames.map(name => {
      const item = list.find(p => p.name === name);
      if (!item) return null;

      // If item has children, sort them too
      if (item.childLookup && item.childLookup.length > 0) {
        const sortedChildNames = this.sortAreasByAlphaNumeric(
          item.childLookup.map(child => child.name || '')
        );

        return {
          ...item,
          childLookup: sortedChildNames.map(childName =>
            item.childLookup!.find(c => c.name === childName)!
          ),
        };
      }

      return item;
    }).filter(item => item !== null) as BusLookup[];
  }
}
